{
  "title_payment": "付款记录",
  "title_receipt": "回款记录",
  "title_application_receipt": "收款记录",
  "title_deposit_receipt": "收定金记录",
  "title_deposit_refund": "退定金记录",
  "title_tax_refund": "退税到账记录",
  "voucher_payment": "付款流水单",
  "voucher_receipt": "回款流水单",
  "voucher_application_receipt": "收款流水单",
  "voucher_deposit_receipt": "收定金流水单",
  "voucher_deposit_refund": "退定金流水单",
  "voucher_tax_refund": "退税凭证",
  "empty": "暂无{{title}}",
  "close": "关闭",
  "view": "查看{{title}}：{{amount}}",
  "loading": "正在加载{{title}}…",
  "load_error": "{{title}}加载失败",
  "retry_hint": "请重试，当前业务数据不会被修改。",
  "retry": "重试",
  "scope_summary": "全范围资金汇总",
  "settled_amount": "来源已结算金额",
  "recorded_amount": "全部记录金额",
  "batch_count": "共 {{count}} 个批次",
  "transaction_no": "资金单号",
  "scope_amount": "本车本批分摊金额",
  "vehicle_hint": "本车金额按批次分摊；银行明细保留整笔交易金额，不代表本车逐笔金额。",
  "inconsistent": "资金汇总与记录不一致",
  "inconsistent_hint": "当前汇总金额缺少对应记录或来源，请联系管理员核对；此处不会补造资金明细。"
}
